/// <amd-module name="TFS/Admin/Groups/Pivots/MemberOf/Redux/MemberOfPivotModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IMemberOfPivotAwareState } from "TFS/Admin/Groups/Common/Contracts";

import { memberOfReducer } from "TFS/Admin/Groups/Pivots/MemberOf/Redux/MemberOfPivotReducers";
import { memberOfSaga } from "TFS/Admin/Groups/Pivots/MemberOf/Redux/MemberOfPivotSaga";

export function getMemberOfPivotModule(): ISagaModule<IMemberOfPivotAwareState> {
    const reducerMap: ReducersMapObject<IMemberOfPivotAwareState, AnyAction> = {
        memberOfState: memberOfReducer
    };

    return {
        id: "memberOfPivotState",
        reducerMap,
        sagas: [memberOfSaga]
    };
}
